<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-25 11:07:21
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-12 20:28:36
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\colonelActivitySquare\detail\components\editDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" title="编辑" width="480px" :before-close="handleClose" :close-on-click-modal="false">
		<el-form :model="form" ref="form" label-width="70px" class="mt-24">
			<el-form-item label="服务费率" prop="investmentPromotionRate">
				<el-input v-model="form.investmentPromotionRate" placeholder="请输入">
					<template slot="append">%</template>
				</el-input>
			</el-form-item>
		</el-form>
		<div class="yx-color-text-primary font-h6-regular ml-4">
			<p>商品要求：</p>
			<p>服务费率不能小于当前报名二级活动要求的最低服务费率，不能大于该商品的一级活动服务费率</p>
		</div>
		<div slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="confirm" :disabled="!isDisable">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { editApplyProduct } from '@/api/secondColonelManage';
export default {
	computed: {
		isDisable({ form }) {
			return form.investmentPromotionRate;
		},
	},
	data() {
		return {
			visible: false,
			form: {
				investmentPromotionRate: '',
			},
			row: {},
			authorityId: '',
		};
	},
	methods: {
		show(row, authorityId) {
			this.row = row;
			this.authorityId = authorityId;
			this.visible = true;
		},
		handleClose() {
			this.form = {
				investmentPromotionRate: '',
			};
			this.visible = false;
		},
		async confirm() {
			const { itemId, preActivityId, activityId } = this.row;
			const { authorityId: authority_id } = this;
			await editApplyProduct({ itemId, preActivityId, activityId, ...this.form, authority_id });
			this.$emit('操作成功！');
			this.$emit('refresh');
			this.handleClose();
		},
	},
};
</script>
<style lang="less" scoped></style>
